export const initCheckoutObject = async (affirm, order) => {
	let customer = order.customer ? order.customer : {};
  const billingAddress = order.billingAddress || {}

	if (order && order.cartlist && order.cartlist.cart && order.cartlist.bigCommerceCart && customer) {
		var hostname = 'https://localhost/checkout/';

		if (typeof window !== 'undefined') {
			hostname = `https://${window.location.hostname}/checkout`;
		}

		let checkOutObjForAffirm = {
			merchant: {
				user_confirmation_url: hostname,
				user_cancel_url: hostname,
			},
			user_confirmation_url_action: 'GET',
			metadata: {
				mode: 'modal',
			},
			shipping: {
				name: {
					full: `${customer.first_name} ${customer.last_name}`,
				},
				address: {
					line1: billingAddress.address1,
					city: billingAddress.city,
					state: billingAddress.state_or_province_code,
					zipcode: billingAddress.postal_code,
					country: billingAddress.country,
				},
			},
			items: [],
			shipping_amount: (
				order.checkout.shipping_cost_total_ex_tax +
				order.checkout.handling_cost_total_ex_tax * 100
			).toFixed(),
			tax_amount: (order.checkout.tax_total * 100).toFixed(),
			total: (order.grand_total * 100).toFixed(),
		};

		// Need to Add Non Physical Items Here
		order.cartlist.bigCommerceCart.line_items.physical_items.forEach(item => {
			checkOutObjForAffirm.items.push({
				display_name: item.name,
				sku: item.sku,
				unit_price: (item.list_price * 100).toFixed(),
				qty: item.quantity,
				item_image_url: item.image_url,
				item_url: item.url,
			});
		});

		return checkOutObjForAffirm;
	} else {
		throw 'SOMETHING WENT WRONG INITIALIZING CHECKOUT OBJ';
	}
};

export const initSingleLineProposition = async (affirm, item, id) => {
	let price = item.price * 100;

	affirm.checkout({
		total: price,
	});
};

export const openCheckout = async (affirm, checkoutObj, setAffirmTokenState, isValidated) => {
	affirm.checkout(checkoutObj);
	affirm.checkout.open({
		onFail: function () {
			console.log('User cancelled the Affirm checkout flow');
		},
		onSuccess: function (a) {
			console.log('Affirm checkout successful, checkout token is: ' + a.checkout_token);
			setAffirmTokenState(a.checkout_token);
			isValidated();
		},
	});
};

export const checkOutInline = async (affirm, checkoutObj, ID) => {
	affirm.checkout(checkoutObj);
	affirm.checkout.inline({
		merchant: {
			inline_container: ID,
		},
	});
};
